module.exports = __webpack_public_path__ + "static/media/dz.fac59eff.jpeg";